/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Notification } from '../../utils/utils';
import { NotificationAction, NotificationActions } from '../actions/notificationActions';
import { AnyAction } from 'redux';
import { actionTypes } from 'redux-router5';
import { uniqWith, isEqual } from 'lodash';

export interface NotificationReducerState {
    notifications: Notification[];
}

const initialState: NotificationReducerState = {
    notifications: [],
};

export function notificationReducer(
    state: NotificationReducerState = initialState,
    action: NotificationAction | AnyAction,
): NotificationReducerState {
    if (action.payload && action.payload.notification) {
        const newList = [...state.notifications, action.payload.notification];

        return {
            notifications: uniqWith(newList, isEqual),
        };
    } else if (action.type === NotificationActions.HIDE_NOTIFICATION) {
        const newList = state.notifications.slice();

        newList.splice(action.payload, 1);

        return {
            notifications: newList,
        };
    } else if (action.type === NotificationActions.HIDE_ALL_NOTIFICATIONS) {
        return {
            notifications: [],
        };
    } else if (
        action.type === actionTypes['TRANSITION_START'] ||
        (action.payload && action.payload.notification === null)
    ) {
        return {
            notifications: [],
        };
    }

    return state;
}
